// Legal content templates for Nida Digital (Anpada XXI · Grupo Laredo Agenjo).
// IMPORTANT: This is a TEMPLATE adapted to Spanish RGPD / LOPDGDD that must be
// reviewed by a qualified legal counsel before going live. Replace the
// placeholders marked as [PENDIENTE] with the company's real data (CIF,
// inscripción registral, DPD, etc.).

const COMPANY = {
    legalName: "Anpada XXI, S.L.",
    brand: "Nida Digital",
    group: "Grupo Laredo Agenjo",
    cif: "[PENDIENTE: CIF]",
    address: "Carretera CM-4005, km 14.5, 45750 Huerta de Valdecarábanos, Toledo (España)",
    email: "hola@nidadigital.es",
    registry: "[PENDIENTE: datos registrales]",
    dpo: "[PENDIENTE: contacto del DPD si aplica]",
    site: "https://nidadigital.es",
    lastUpdated: { es: "Diciembre 2025", en: "December 2025" },
};

export const legalCompany = COMPANY;

const upd = (lang) => COMPANY.lastUpdated[lang];

export const legalContent = {
    privacy: {
        es: {
            title: "Política de privacidad",
            updated: `Última actualización: ${upd("es")}`,
            intro: `En ${COMPANY.brand} (${COMPANY.legalName}) tratamos tus datos personales con el máximo respeto y en cumplimiento del Reglamento (UE) 2016/679 (RGPD) y de la Ley Orgánica 3/2018, de 5 de diciembre, de Protección de Datos Personales y garantía de los derechos digitales (LOPDGDD).`,
            sections: [
                {
                    title: "1. Responsable del tratamiento",
                    paragraphs: [
                        `Razón social: ${COMPANY.legalName} (${COMPANY.group}).`,
                        `CIF: ${COMPANY.cif}.`,
                        `Domicilio: ${COMPANY.address}.`,
                        `Email de contacto: ${COMPANY.email}.`,
                        `Datos registrales: ${COMPANY.registry}.`,
                        `Delegado de Protección de Datos (DPD): ${COMPANY.dpo}.`,
                    ],
                },
                {
                    title: "2. Finalidades del tratamiento y base jurídica",
                    paragraphs: [
                        "Tratamos los datos que nos facilitas a través del formulario de contacto y de los demás canales habilitados con las siguientes finalidades:",
                    ],
                    list: [
                        "Atender tu solicitud de información, presupuesto o asesoría — base jurídica: ejecución de un contrato o aplicación de medidas precontractuales (art. 6.1.b RGPD).",
                        "Mantener la relación comercial y contractual posterior — base jurídica: ejecución del contrato (art. 6.1.b RGPD).",
                        "Cumplir con obligaciones legales (fiscales, mercantiles, laborales) — base jurídica: cumplimiento de una obligación legal (art. 6.1.c RGPD).",
                        "Enviarte comunicaciones comerciales sobre nuestros servicios cuando exista relación previa o consentimiento expreso — base jurídica: interés legítimo o consentimiento (arts. 6.1.f y 6.1.a RGPD).",
                        "Gestionar y mejorar nuestra web mediante cookies y herramientas de analítica — base jurídica: consentimiento (art. 6.1.a RGPD).",
                    ],
                },
                {
                    title: "3. Datos que tratamos",
                    paragraphs: [
                        "Tratamos los datos que nos proporcionas voluntariamente, generalmente: nombre, empresa, email, teléfono, servicio de interés y el contenido del mensaje. No recogemos categorías especiales de datos.",
                        "Si nos contactas en nombre de una empresa, deberás disponer de la autorización adecuada para facilitarnos tus datos profesionales.",
                    ],
                },
                {
                    title: "4. Plazo de conservación",
                    paragraphs: [
                        "Conservaremos tus datos durante el tiempo necesario para cumplir la finalidad para la que se recabaron y, posteriormente, durante los plazos legalmente exigidos para atender posibles responsabilidades (generalmente entre 4 y 6 años en materia fiscal y mercantil).",
                        "Si solicitas la supresión, los bloquearemos para atender obligaciones legales hasta su completa eliminación.",
                    ],
                },
                {
                    title: "5. Destinatarios y encargados del tratamiento",
                    paragraphs: [
                        "No comunicamos tus datos a terceros, salvo a las administraciones públicas cuando exista obligación legal o a proveedores tecnológicos que actúan como encargados del tratamiento (hosting, herramientas de email, CRM, analítica). Estos prestadores están sujetos a contrato de encargo conforme al art. 28 RGPD.",
                        "Pueden producirse transferencias internacionales fuera del EEE únicamente con proveedores que ofrezcan garantías adecuadas (cláusulas contractuales tipo de la Comisión Europea u otros mecanismos válidos).",
                    ],
                },
                {
                    title: "6. Tus derechos",
                    paragraphs: [
                        "Puedes ejercer en cualquier momento los derechos de acceso, rectificación, supresión, oposición, limitación del tratamiento, portabilidad y a no ser objeto de decisiones automatizadas, escribiendo a:",
                    ],
                    list: [
                        `Email: ${COMPANY.email}`,
                        `Correo postal: ${COMPANY.address}`,
                    ],
                    paragraphsAfter: [
                        "Adjunta una copia de tu DNI o documento identificativo equivalente. También tienes derecho a presentar una reclamación ante la Agencia Española de Protección de Datos (www.aepd.es) cuando consideres que el tratamiento no se ajusta a la normativa.",
                    ],
                },
                {
                    title: "7. Seguridad",
                    paragraphs: [
                        "Aplicamos medidas técnicas y organizativas adecuadas al riesgo del tratamiento, alineadas con el Esquema Nacional de Seguridad (ENS), ISO/IEC 27001 y la Directiva NIS2, incluyendo cifrado en tránsito, control de accesos, copias de seguridad y monitorización continua.",
                    ],
                },
                {
                    title: "8. Cambios en esta política",
                    paragraphs: [
                        "Podemos actualizar esta política para adaptarla a cambios legales u operativos. Publicaremos siempre la versión vigente en esta página, indicando la fecha de la última revisión.",
                    ],
                },
            ],
        },
        en: {
            title: "Privacy policy",
            updated: `Last updated: ${upd("en")}`,
            intro: `At ${COMPANY.brand} (${COMPANY.legalName}) we process your personal data in compliance with Regulation (EU) 2016/679 (GDPR) and the Spanish Organic Law 3/2018 on Personal Data Protection (LOPDGDD).`,
            sections: [
                {
                    title: "1. Data controller",
                    paragraphs: [
                        `Legal name: ${COMPANY.legalName} (${COMPANY.group}).`,
                        `Tax ID (CIF): ${COMPANY.cif}.`,
                        `Address: ${COMPANY.address}.`,
                        `Contact email: ${COMPANY.email}.`,
                        `Registry data: ${COMPANY.registry}.`,
                        `Data Protection Officer: ${COMPANY.dpo}.`,
                    ],
                },
                {
                    title: "2. Purposes and legal basis",
                    paragraphs: [
                        "We process the data you provide through our contact form and other enabled channels for the following purposes:",
                    ],
                    list: [
                        "Handling your request for information, quote or consultation — legal basis: contract execution or pre-contractual measures (art. 6.1.b GDPR).",
                        "Maintaining the commercial and contractual relationship — legal basis: contract execution (art. 6.1.b GDPR).",
                        "Complying with legal obligations (tax, commercial, labor) — legal basis: compliance with a legal obligation (art. 6.1.c GDPR).",
                        "Sending commercial communications about our services where a prior relationship or explicit consent exists — legal basis: legitimate interest or consent (arts. 6.1.f and 6.1.a GDPR).",
                        "Managing and improving our website via cookies and analytics — legal basis: consent (art. 6.1.a GDPR).",
                    ],
                },
                {
                    title: "3. Data we process",
                    paragraphs: [
                        "We process the data you voluntarily provide, typically: name, company, email, phone, service of interest and message content. We do not collect special categories of data.",
                        "If you contact us on behalf of a company, you must have proper authorization to share your professional data.",
                    ],
                },
                {
                    title: "4. Retention period",
                    paragraphs: [
                        "We will keep your data for the time needed to fulfill the original purpose and, afterwards, for the legally required periods (typically 4–6 years for tax and commercial matters).",
                        "If you request deletion, we will block your data to meet legal obligations until it is fully removed.",
                    ],
                },
                {
                    title: "5. Recipients and processors",
                    paragraphs: [
                        "We do not share your data with third parties, except with public administrations when legally required, or with technology providers acting as processors (hosting, email, CRM, analytics). These providers are bound by a processor agreement under art. 28 GDPR.",
                        "International transfers outside the EEA only occur with providers offering adequate safeguards (EU Standard Contractual Clauses or other valid mechanisms).",
                    ],
                },
                {
                    title: "6. Your rights",
                    paragraphs: [
                        "You can exercise your rights to access, rectification, deletion, objection, processing limitation, portability and not to be subject to automated decisions by writing to:",
                    ],
                    list: [
                        `Email: ${COMPANY.email}`,
                        `Postal address: ${COMPANY.address}`,
                    ],
                    paragraphsAfter: [
                        "Attach a copy of your ID. You also have the right to lodge a complaint with the Spanish Data Protection Agency (www.aepd.es).",
                    ],
                },
                {
                    title: "7. Security",
                    paragraphs: [
                        "We apply technical and organizational measures appropriate to the risk, aligned with the Spanish National Security Scheme (ENS), ISO/IEC 27001 and the NIS2 Directive, including encryption in transit, access control, backups and continuous monitoring.",
                    ],
                },
                {
                    title: "8. Changes to this policy",
                    paragraphs: [
                        "We may update this policy to reflect legal or operational changes. The current version is always available on this page, with the date of the last revision.",
                    ],
                },
            ],
        },
    },
    terms: {
        es: {
            title: "Términos y condiciones",
            updated: `Última actualización: ${upd("es")}`,
            intro: `Las presentes condiciones regulan el acceso y el uso del sitio web ${COMPANY.site} (en adelante, el "Sitio"), titularidad de ${COMPANY.legalName}, marca comercial ${COMPANY.brand}, perteneciente al ${COMPANY.group}.`,
            sections: [
                {
                    title: "1. Identificación del titular",
                    paragraphs: [
                        `Razón social: ${COMPANY.legalName}.`,
                        `CIF: ${COMPANY.cif}.`,
                        `Domicilio: ${COMPANY.address}.`,
                        `Email: ${COMPANY.email}.`,
                        `Datos registrales: ${COMPANY.registry}.`,
                    ],
                },
                {
                    title: "2. Aceptación de las condiciones",
                    paragraphs: [
                        "El acceso al Sitio implica el conocimiento y aceptación expresa de las presentes condiciones, así como de la política de privacidad y la política de cookies. Si no estás de acuerdo con cualquiera de ellas, debes abstenerte de utilizar el Sitio.",
                    ],
                },
                {
                    title: "3. Acceso y uso",
                    paragraphs: [
                        "El acceso al Sitio es libre y gratuito, salvo en lo relativo al coste de conexión a la red del proveedor del usuario.",
                        "El usuario se compromete a hacer un uso diligente, correcto y lícito del Sitio y, en particular, a no emplearlo con fines o efectos ilícitos, contrarios al orden público o lesivos para los derechos e intereses de terceros.",
                    ],
                },
                {
                    title: "4. Propiedad intelectual e industrial",
                    paragraphs: [
                        `Todos los contenidos del Sitio (textos, imágenes, gráficos, logotipos, código, diseños) son propiedad de ${COMPANY.legalName} o de terceros que han autorizado su uso, y están protegidos por las leyes de propiedad intelectual e industrial.`,
                        "Queda prohibida la reproducción, distribución, comunicación pública o transformación de dichos contenidos sin autorización expresa y por escrito del titular.",
                    ],
                },
                {
                    title: "5. Responsabilidad",
                    paragraphs: [
                        `${COMPANY.brand} adopta medidas razonables para garantizar la disponibilidad del Sitio, pero no garantiza la inexistencia de interrupciones o errores. Tampoco será responsable de los daños o perjuicios derivados del uso del Sitio o de la confianza depositada en su contenido informativo.`,
                        "Los presupuestos, propuestas o materiales informativos publicados tienen carácter orientativo y no constituyen oferta vinculante salvo acuerdo expreso por escrito.",
                    ],
                },
                {
                    title: "6. Enlaces a terceros",
                    paragraphs: [
                        `El Sitio puede contener enlaces a páginas de terceros sobre cuyo contenido ${COMPANY.brand} no asume ninguna responsabilidad. La inclusión de estos enlaces no implica recomendación, asociación o respaldo del contenido enlazado.`,
                    ],
                },
                {
                    title: "7. Protección de datos y cookies",
                    paragraphs: [
                        "El tratamiento de datos personales y el uso de cookies se regulan en la política de privacidad y la política de cookies, que forman parte integrante de estos términos.",
                    ],
                },
                {
                    title: "8. Modificaciones",
                    paragraphs: [
                        `${COMPANY.brand} se reserva el derecho a modificar estas condiciones en cualquier momento. Las modificaciones serán efectivas desde su publicación en el Sitio.`,
                    ],
                },
                {
                    title: "9. Legislación aplicable y jurisdicción",
                    paragraphs: [
                        "Estas condiciones se rigen por la legislación española. Para la resolución de cualquier controversia derivada de su interpretación o aplicación, las partes se someten a los Juzgados y Tribunales del domicilio del titular, salvo que la legislación aplicable disponga otra cosa imperativamente.",
                    ],
                },
            ],
        },
        en: {
            title: "Terms and conditions",
            updated: `Last updated: ${upd("en")}`,
            intro: `These terms govern access to and use of ${COMPANY.site} (the "Site"), owned by ${COMPANY.legalName}, trading as ${COMPANY.brand}, part of the ${COMPANY.group}.`,
            sections: [
                {
                    title: "1. Owner identification",
                    paragraphs: [
                        `Legal name: ${COMPANY.legalName}.`,
                        `Tax ID (CIF): ${COMPANY.cif}.`,
                        `Address: ${COMPANY.address}.`,
                        `Email: ${COMPANY.email}.`,
                        `Registry data: ${COMPANY.registry}.`,
                    ],
                },
                {
                    title: "2. Acceptance of terms",
                    paragraphs: [
                        "Accessing the Site means you accept these terms, the privacy policy and the cookie policy. If you do not agree with any of them, please do not use the Site.",
                    ],
                },
                {
                    title: "3. Access and use",
                    paragraphs: [
                        "Access to the Site is free, except for any internet connection costs charged by your provider.",
                        "You agree to make diligent, correct and lawful use of the Site, and in particular not to use it for unlawful purposes or in a way that harms the rights of third parties.",
                    ],
                },
                {
                    title: "4. Intellectual property",
                    paragraphs: [
                        `All Site contents (texts, images, graphics, logos, code, designs) are owned by ${COMPANY.legalName} or by third parties who have authorized their use, and are protected by IP laws.`,
                        "Reproduction, distribution, public communication or transformation of these contents is prohibited without prior written authorization from the owner.",
                    ],
                },
                {
                    title: "5. Liability",
                    paragraphs: [
                        `${COMPANY.brand} takes reasonable measures to ensure Site availability but does not warrant the absence of interruptions or errors, nor liability for damages arising from use of the Site or reliance on its informational content.`,
                        "Budgets, proposals or informational materials published are indicative and do not constitute a binding offer unless expressly agreed in writing.",
                    ],
                },
                {
                    title: "6. Third-party links",
                    paragraphs: [
                        `The Site may include links to third-party sites for whose content ${COMPANY.brand} accepts no responsibility. Their inclusion does not imply endorsement.`,
                    ],
                },
                {
                    title: "7. Data protection and cookies",
                    paragraphs: [
                        "Personal data processing and cookie usage are governed by the privacy policy and cookie policy, which are an integral part of these terms.",
                    ],
                },
                {
                    title: "8. Changes",
                    paragraphs: [
                        `${COMPANY.brand} reserves the right to amend these terms at any time. Changes are effective upon publication on the Site.`,
                    ],
                },
                {
                    title: "9. Governing law and jurisdiction",
                    paragraphs: [
                        "These terms are governed by Spanish law. Any dispute will be submitted to the courts of the owner's domicile, unless mandatory law states otherwise.",
                    ],
                },
            ],
        },
    },
    cookies: {
        es: {
            title: "Política de cookies",
            updated: `Última actualización: ${upd("es")}`,
            intro: `Esta política explica qué son las cookies, qué tipos utiliza el sitio ${COMPANY.site} y cómo puedes gestionarlas. Forma parte integrante de la política de privacidad.`,
            sections: [
                {
                    title: "1. ¿Qué es una cookie?",
                    paragraphs: [
                        "Una cookie es un pequeño archivo que se descarga en tu dispositivo cuando visitas un sitio web. Permite al sitio recordar información sobre tu visita, como tu idioma preferido o las acciones que realizas.",
                    ],
                },
                {
                    title: "2. Categorías de cookies que utilizamos",
                    paragraphs: ["Clasificamos nuestras cookies según su finalidad y obligatoriedad:"],
                    list: [
                        "Cookies estrictamente necesarias (esenciales): permiten el funcionamiento básico del sitio y no requieren consentimiento (por ejemplo, idioma seleccionado).",
                        "Cookies de analítica: nos ayudan a entender cómo se usa el sitio y a mejorarlo. Solo se activan con tu consentimiento.",
                        "Cookies de marketing: utilizadas para mostrarte contenido relevante o medir campañas. Solo se activan con tu consentimiento.",
                    ],
                },
                {
                    title: "3. Detalle de cookies",
                    table: {
                        head: ["Cookie", "Tipo", "Finalidad", "Duración"],
                        rows: [
                            ["nida_lang", "Esencial", "Recordar el idioma seleccionado por el usuario.", "1 año"],
                            ["nida_cookie_consent", "Esencial", "Almacenar tus preferencias de cookies para no volver a preguntarte.", "6 meses"],
                            ["nida_admin_token", "Esencial", "Mantener la sesión del panel de administración.", "Sesión"],
                            ["_ga / _ga_*", "Analítica (opt-in)", "Métricas agregadas de uso del sitio.", "Hasta 2 años"],
                        ],
                    },
                    paragraphsAfter: [
                        "El listado podrá ampliarse con nuevas herramientas. En ese caso, se actualizará esta política y, si procede, se solicitará un nuevo consentimiento.",
                    ],
                },
                {
                    title: "4. Cómo gestionar tus preferencias",
                    paragraphs: [
                        "Puedes aceptar, rechazar o personalizar las cookies desde el banner que se muestra al entrar en el sitio. También puedes modificar tu elección en cualquier momento desde el siguiente botón:",
                    ],
                    action: "openCookiePreferences",
                },
                {
                    title: "5. Cómo desactivar las cookies en tu navegador",
                    paragraphs: [
                        "Además de nuestro panel de preferencias, puedes configurar las cookies directamente desde tu navegador. Aquí tienes los enlaces oficiales:",
                    ],
                    links: [
                        ["Google Chrome", "https://support.google.com/chrome/answer/95647"],
                        ["Mozilla Firefox", "https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias"],
                        ["Apple Safari", "https://support.apple.com/es-es/guide/safari/sfri11471/mac"],
                        ["Microsoft Edge", "https://support.microsoft.com/es-es/microsoft-edge"],
                    ],
                    paragraphsAfter: [
                        "Recuerda que desactivar ciertas cookies puede afectar al funcionamiento o experiencia en el sitio.",
                    ],
                },
            ],
        },
        en: {
            title: "Cookie policy",
            updated: `Last updated: ${upd("en")}`,
            intro: `This policy explains what cookies are, which ones ${COMPANY.site} uses and how you can manage them. It is part of the privacy policy.`,
            sections: [
                {
                    title: "1. What is a cookie?",
                    paragraphs: [
                        "A cookie is a small file downloaded to your device when you visit a website. It allows the site to remember information about your visit, such as your preferred language or your actions.",
                    ],
                },
                {
                    title: "2. Categories of cookies we use",
                    paragraphs: ["We classify cookies by purpose:"],
                    list: [
                        "Strictly necessary (essential) cookies: enable basic site functions and do not require consent (e.g. language selection).",
                        "Analytics cookies: help us understand how the site is used to improve it. Activated only with your consent.",
                        "Marketing cookies: used to deliver relevant content or measure campaigns. Activated only with your consent.",
                    ],
                },
                {
                    title: "3. Cookie details",
                    table: {
                        head: ["Cookie", "Type", "Purpose", "Duration"],
                        rows: [
                            ["nida_lang", "Essential", "Remember the language selected by the user.", "1 year"],
                            ["nida_cookie_consent", "Essential", "Store your cookie preferences so we don't ask again.", "6 months"],
                            ["nida_admin_token", "Essential", "Keep the admin dashboard session.", "Session"],
                            ["_ga / _ga_*", "Analytics (opt-in)", "Aggregated usage metrics.", "Up to 2 years"],
                        ],
                    },
                    paragraphsAfter: [
                        "The list may be extended with new tools. In that case this policy will be updated and a new consent may be requested.",
                    ],
                },
                {
                    title: "4. Managing your preferences",
                    paragraphs: [
                        "You can accept, reject or personalize cookies from the banner shown on first visit. You can also change your choice anytime from the button below:",
                    ],
                    action: "openCookiePreferences",
                },
                {
                    title: "5. Disabling cookies in your browser",
                    paragraphs: [
                        "Beyond our preference panel, you can configure cookies directly in your browser. Official guides:",
                    ],
                    links: [
                        ["Google Chrome", "https://support.google.com/chrome/answer/95647"],
                        ["Mozilla Firefox", "https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer"],
                        ["Apple Safari", "https://support.apple.com/guide/safari/manage-cookies-sfri11471/mac"],
                        ["Microsoft Edge", "https://support.microsoft.com/en-us/microsoft-edge"],
                    ],
                    paragraphsAfter: [
                        "Note that disabling some cookies may affect site functionality or experience.",
                    ],
                },
            ],
        },
    },
};

export const legalUI = {
    es: {
        backHome: "Volver al inicio",
        eyebrow: "Legal",
        disclaimer:
            "Este documento es una plantilla orientativa. Antes de su publicación definitiva debe ser revisado y validado por asesoría legal con los datos identificativos definitivos de la empresa.",
        privacy: "Política de privacidad",
        terms: "Términos y condiciones",
        cookies: "Política de cookies",
        managePrefs: "Gestionar preferencias de cookies",
    },
    en: {
        backHome: "Back to home",
        eyebrow: "Legal",
        disclaimer:
            "This document is an orientation template. Before going live it must be reviewed and validated by legal counsel using the company's final identification data.",
        privacy: "Privacy policy",
        terms: "Terms and conditions",
        cookies: "Cookie policy",
        managePrefs: "Manage cookie preferences",
    },
};

export const cookieBannerCopy = {
    es: {
        title: "Tu privacidad importa",
        body: "Usamos cookies propias y de terceros para que el sitio funcione correctamente, recordar tus preferencias y, con tu consentimiento, medir el uso del sitio. Puedes aceptarlas, rechazarlas o personalizarlas en cualquier momento.",
        accept: "Aceptar todas",
        reject: "Rechazar opcionales",
        customize: "Personalizar",
        save: "Guardar preferencias",
        readMore: "Más información",
        cats: {
            essential: { title: "Esenciales", desc: "Necesarias para el funcionamiento básico. No se pueden desactivar." },
            analytics: { title: "Analítica", desc: "Métricas agregadas para entender cómo se usa el sitio." },
            marketing: { title: "Marketing", desc: "Usadas para mostrar contenido y campañas relevantes." },
        },
    },
    en: {
        title: "Your privacy matters",
        body: "We use first- and third-party cookies for the site to work properly, remember your preferences and, with your consent, measure site usage. You can accept, reject or personalize at any time.",
        accept: "Accept all",
        reject: "Reject optional",
        customize: "Customize",
        save: "Save preferences",
        readMore: "Learn more",
        cats: {
            essential: { title: "Essential", desc: "Required for the site to work. Cannot be disabled." },
            analytics: { title: "Analytics", desc: "Aggregated metrics to understand how the site is used." },
            marketing: { title: "Marketing", desc: "Used to deliver relevant content and campaigns." },
        },
    },
};
